"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const portalInternetTradingPolicyConfig_1 = __importDefault(require("../portalInternetTradingPolicyConfig"));
class PortalLegalConfig {
    constructor(internetTradingPolicy) {
        this.internetTradingPolicy = internetTradingPolicy;
    }
    static fromObj(data) {
        if (!data || !data.internetTradingPolicy) {
            throw new Error("Portal config is not loaded successfully");
        }
        return new PortalLegalConfig(portalInternetTradingPolicyConfig_1.default.fromObj(data.internetTradingPolicy));
    }
}
exports.default = PortalLegalConfig;
//# sourceMappingURL=portalLegalConfig.class.js.map